import { Link, Stack, Typography } from "@mui/material";
import type { ID } from "../../data/BaseEntity";
import type { FC } from "react";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import CustomerOrdersStats from "./CustomerOrdersStats";
import dayjs from "../../dayjs";
import { Select } from "../../components/select/Select";
import range from "lodash/range";
import CustomerCalculationsStats from "./CustomerCalculationsStats";
import CustomerDetails from "./CustomerDetails";

interface YearPickerProps {
  readonly value: number;
  readonly onChange: (value: number) => void;
}

const YearPicker: FC<YearPickerProps> = ({ value, onChange }) => {
  const currentYear = dayjs().year();
  const values = range(currentYear - 4, currentYear + 1).map((v) => ({ value: `${v}` }));
  return (
    <Select
      size="small"
      label="Rok"
      fullWidth
      value={`${value}`}
      values={values}
      onSelect={(v) => onChange(Number.parseInt(v))}
    />
  );
};

interface Props {
  readonly customerId: ID;
}

const CustomerOverview: FC<Props> = ({ customerId }) => {
  const [year, setYear] = useState(dayjs().year());
  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{
        width: "100%",
      }}
    >
      <YearPicker value={year} onChange={setYear} />
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Zamówienia</Typography>
      </Stack>
      <CustomerOrdersStats customerId={customerId} year={year} />
      <Typography variant="body2">
        <Link to={`/orders?customerId=${customerId}`} target="_blank" component={RouterLink}>
          Zobacz zamówienia
        </Link>
      </Typography>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Kalkulacje</Typography>
      </Stack>
      <CustomerCalculationsStats customerId={customerId} year={year} />
      <Typography variant="body2">
        <Link to={`/calculations?customerId=${customerId}`} target="_blank" component={RouterLink}>
          Zobacz kalkulacje
        </Link>
      </Typography>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Dodatkowe informacje</Typography>
      </Stack>
      <CustomerDetails customerId={customerId} />
    </Stack>
  );
};

export default CustomerOverview;
